module.exports = __webpack_public_path__ + "static/media/logo.cf360ecc.png";